// @ts-ignore
import { portTypes } from '@tera/shared/src/fluxoConfig/ports/portType'
// @ts-ignore
import themes from '@tera/shared/src/fluxoConfig/themes'
import CampoTexto from '../../components/Formulario/CampoTexto'
import Icon from '../../components/Icon'
import { mdiCircle, mdiPlus, mdiTrashCan } from '@mdi/js'
import Botao from '../../components/Botao'
import VBox from '../../components/layout/VBox'
import BotaoPerigoso from '../../components/BotaoPerigoso'
import CampoSeletor from '../../components/Formulario/CampoSeletor'
import Grid, { GridItem } from '../../components/layout/Grid'
import CampoCheckbox from '../../components/Formulario/CampoCheckbox'

export type IntegracaoApiEndpointEntrada = {
    nome: string,
    caminho_jsonpath: string,
    tipo: string,
    valor_padrao?: string,
    aceita_nulo?: boolean
}

export type FormApiEntradasProps = {
    value: IntegracaoApiEndpointEntrada[],
    onChange: (value: IntegracaoApiEndpointEntrada[]) => void,
    fieldErrors: Record<string, string> | null
}

export const FormApiEntradas = ({ value, onChange, fieldErrors }: FormApiEntradasProps) => {
    const tiposEntradaOptions = portTypes.map(it => ({
        id: it.type,
        label: <span>
            <Icon path={mdiCircle} size={1} color={themes.common.ports[it.type as keyof typeof themes.common.ports]?.color as string ?? 'gray'} /> {it.label}
        </span>
    }))

    const handleAddEntrada = () => {
        onChange([
            ...(value ?? []),
            {
                nome: '',
                tipo: '',
                caminho_jsonpath: '',
                aceita_nulo: false
            }
        ])
    }

    const handleDelEntrada = (idx: number) => {
        onChange([
            ...(value ?? []).filter((_: any, i: number) => i !== idx)
        ])
    }

    return (
        <VBox>
            <div style={{ textAlign: 'end' }}>
                <Botao variant='none-primary' icon={mdiPlus} onClick={handleAddEntrada}>Adicionar entrada</Botao>
            </div>

            {value?.map && value?.map((it: any, idx: number) => (
                <Grid key={idx}>
                    <GridItem sm={3}>
                        <CampoTexto
                            value={it.nome}
                            onChange={(v) => onChange([
                                ...(value ?? []).map((e: any, i: number) => i === idx ? { ...e, nome: v, caminho_jsonpath: `$.${v.replace(/[^0-9a-zA-Z-_]/g, '_')}` } : e)
                            ])}
                            label='Nome'
                            error={fieldErrors?.[`[${idx}].nome`]}
                        />
                    </GridItem>
                    <GridItem sm={3}>
                        <CampoTexto
                            value={it.caminho_jsonpath}
                            onChange={(v) => onChange([
                                ...(value ?? []).map((e: any, i: number) => i === idx ? { ...e, caminho_jsonpath: v } : e)
                            ])}
                            placeholder='JSONPath. Ex: $.caminho.ate.valor'
                            label='Caminho'
                            error={fieldErrors?.[`[${idx}].caminho_jsonpath`]}
                        />
                    </GridItem>
                    <GridItem sm={2}>
                        <CampoSeletor
                            options={tiposEntradaOptions}
                            value={it.tipo}
                            onChange={(v) => onChange([
                                ...(value ?? []).map((e: any, i: number) => i === idx ? { ...e, tipo: v } : e)
                            ])}
                            label='Tipo'
                            error={fieldErrors?.[`[${idx}].tipo`]}
                        />
                    </GridItem>
                    <GridItem sm={2}>
                        <CampoTexto
                            value={it.valor_padrao}
                            onChange={(v) => onChange([
                                ...(value ?? []).map((e: any, i: number) => i === idx ? { ...e, valor_padrao: v } : e)
                            ])}
                            label='Vl. Padrão'
                            error={fieldErrors?.[`[${idx}].valor_padrao`]}
                        />
                    </GridItem>
                    <GridItem sm={1}>
                        <CampoCheckbox
                            label='Aceita nulo'
                            value={it.aceita_nulo ?? false}
                            onChange={(v) => onChange([
                                ...(value ?? []).map((e: any, i: number) => i === idx ? { ...e, aceita_nulo: v } : e)
                            ])}
                        />
                    </GridItem>
                    <GridItem sm={1}>
                        <label>&nbsp;</label>
                        <div>
                            <BotaoPerigoso
                                variant='none-danger'
                                icon={mdiTrashCan}
                                onClick={() => handleDelEntrada(idx)}
                            ></BotaoPerigoso>
                        </div>
                    </GridItem>
                </Grid>

            ))}
        </VBox>
    )
}
